import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, getDocs, deleteDoc, doc, updateDoc } from "firebase/firestore";
import CIcon from "@coreui/icons-react";
import { cilImage, cilVideo, cilDescription } from "@coreui/icons";
import "./Playlists.css";
import SetToScreenModal from "../components/SetToScreenModal"; // New modal component

const Playlists = () => {
  const [playlists, setPlaylists] = useState([]);
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [isSetToScreenModalOpen, setIsSetToScreenModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPlaylists = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "playlists"));
        const playlistData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPlaylists(playlistData);
      } catch (err) {
        console.error("Error fetching playlists:", err);
      }
    };

    fetchPlaylists();
  }, []);

  const getMediaTypeIcons = (items) => {
    if (!items || items.length === 0) return "No Media";
  
    const uniqueTypes = new Set(items.map((item) => item.mediaType));
  
    return [...uniqueTypes].map((type, index) => (
      <CIcon
        key={index}
        icon={getMediaTypeIcon(type)}
        className="media-type-icon"
        style={{ width: "16px", height: "16px", minWidth: "16px", minHeight: "16px" }} // ✅ Force small size
      />
    ));
  };
  
  

  const getMediaTypeIcon = (type) => {
    switch (type) {
      case "image":
        return cilImage;
      case "video":
        return cilVideo;
      case "document":
        return cilDescription;
      default:
        return null;
    }
  };

  const handleCreatePlaylist = () => {
    navigate("/playlist");
  };

  const handleEditPlaylist = (playlistId) => {
    navigate(`/playlist/${playlistId}`);
  };

  const handleDeletePlaylist = async (playlistId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this playlist?");
    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, "playlists", playlistId));
      setPlaylists((prev) => prev.filter((p) => p.id !== playlistId));
    } catch (err) {
      console.error("Error deleting playlist:", err.message);
      alert("Failed to delete playlist. Please try again.");
    }
  };

  // Open modal for setting playlist to screen
  const openSetToScreenModal = (playlist) => {
    setSelectedPlaylist(playlist);
    setIsSetToScreenModalOpen(true);
  };

  return (
    <div className="playlists-container">
      {/* Header Section */}
      <div className="playlists-header">
        <h1 className="playlists-title">Playlists</h1>
        <button className="btn add-playlist" onClick={handleCreatePlaylist}>
          Create Playlist
        </button>
      </div>

      {/* Search Bar */}
      <div className="search-bar-container left-aligned">
        <input
          type="text"
          placeholder="Search playlists..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-bar"
        />
      </div>

      {/* Playlists Table */}
      <div className="playlists-table-container">
        <table className="playlists-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Last Modified</th>
              <th>Media Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {playlists
              .filter((playlist) =>
                playlist.name.toLowerCase().includes(searchQuery.toLowerCase())
              )
              .map((playlist) => (
                <tr key={playlist.id}>
                  <td>{playlist.name}</td>
                  <td>{playlist.description || "N/A"}</td>
                  <td>
                    {playlist.lastModified
                      ? playlist.lastModified.toDate().toLocaleDateString()
                      : "Unknown"}
                  </td>
                  <td className="media-icons-column">{getMediaTypeIcons(playlist.items)}</td>
                  <td>
                    <button className="btn edit" onClick={() => handleEditPlaylist(playlist.id)}>
                      Edit
                    </button>
                    <button className="btn delete" onClick={() => handleDeletePlaylist(playlist.id)}>
                      Delete
                    </button>
                    <button className="btn set-to-screen" onClick={() => openSetToScreenModal(playlist)}>
                      Set to Screen
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {/* Set to Screen Modal */}
      <SetToScreenModal
        isOpen={isSetToScreenModalOpen}
        onClose={() => setIsSetToScreenModalOpen(false)}
        playlist={selectedPlaylist}
      />
    </div>
  );
};

export default Playlists;
